import { Component, EventEmitter, HostBinding, OnInit, Output } from '@angular/core';
import { MSelector, MStaticClient, MStaticInter, MUser } from '@argalis-apps/models';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { StaticService } from '../../../services/static/static.service';
import { ConfigService } from '@argalis-apps/angular-global';
import { SelectorService } from '../../../services/selector/selector.service';
import { UtilisateurService } from '../../../services/utilisateur/utilisateur.service';
import { AuthService } from '../../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-header-calendar',
  templateUrl: './header-calendar.component.html',
  styleUrls: ['./header-calendar.component.scss']
})
export class HeaderCalendarComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Output() filterClicked = new EventEmitter<any>();

  public getMoreFilter = true;
  public staticRequest: MStaticClient.IStaticClientRequest | MStaticInter.IStaticInterRequest = {} as
    | MStaticClient.IStaticClientRequest
    | MStaticInter.IStaticInterRequest;
  public statut_session: MSelector.IStatut_Session[];
  public isInter: boolean;
  public data;
  public id: number;
  public userConnected: MUser.CUser;
  public cardVisualisation: MStaticClient.ICardVisualisationClient | MStaticInter.IStatistiqueCardVisualisationInter;
  public listProduits: MSelector.IProduit[];
  public listSector: MSelector.ISector[];
  public listGroup: MSelector.IFamile_Group_Site[];
  public listSite: MSelector.IFamile_Group_Site[];
  public listFamile: MSelector.IFamile_Group_Site[];
  public listResponsableAdministratif: MUser.IClient[];
  public bouttonsups: MSelector.IStatut_Session[] = [
    {
      id: '100',
      libelle: `Proposition d'encadrement`,
      couleur: 'statut-16',
      code: 'PROP',
      id_organisme_formation: null
    },
    { id: '101', libelle: 'Indisponibilités', couleur: 'statut-17', code: 'INDISP', id_organisme_formation: null }
  ];

  constructor(
    private accountConfigService: AccountConfigService,
    private staticService: StaticService,
    private configService: ConfigService,
    private authService: AuthService,
    private selectorService: SelectorService,
    private utlisateurService: UtilisateurService
  ) {
    this.isInter = this.configService.getETypeUser().valueOf() === MUser.ETypeUser.FORMATEUR.valueOf();
    this.userConnected = this.authService.userConnected;
    this.getListStatut_session();
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
    this.id = this.userConnected.userInfo.id;
  }

  ngOnInit() {
    this.chargeDropList();
    this.staticRequest.listeProduitSecteur = [];
    this.staticRequest.listeProduitFamille = [];
    this.staticRequest.listeProduitGroupe = [];
    this.staticRequest.listeProduit = [];
    this.staticRequest.listResponsableAdministratif = [];
    this.staticRequest.listeSessionStatut = [];
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }

  chargeDropList() {
    this.getListProduits();
    this.getListSector();
    this.getListGroup();
    this.getListFamile();
    this.getResponsableAdministratif();
    // if (!this.isInter) this.getListSite();
  }

  getListProduits() {
    this.selectorService.getListProduit().subscribe(
      produit => {
        this.listProduits = produit;
      },
      () => {
        this.listProduits = [];
      }
    );
  }

  getListSector() {
    this.selectorService.getListSector().subscribe(
      sectors => {
        this.listSector = sectors;
      },
      () => {
        this.listSector = [];
      }
    );
  }
  getListGroup() {
    this.selectorService.getListGroup().subscribe(
      groups => {
        this.listGroup = groups;
      },
      () => {
        this.listGroup = [];
      }
    );
  }
  getListFamile() {
    this.selectorService.getListFamile().subscribe(
      familes => {
        this.listFamile = familes;
      },
      () => {
        this.listFamile = [];
      }
    );
  }

  getResponsableAdministratif() {
    this.utlisateurService.getListResponsableAdministratif().subscribe(
      responsableAdministratif => {
        this.listResponsableAdministratif = responsableAdministratif;
      },
      () => {
        this.listResponsableAdministratif = [];
      }
    );
  }

  moreFilter() {
    this.getMoreFilter = !this.getMoreFilter;
  }

  selectStatut(statut_session: MSelector.IStatut_Session) {
    if (this.staticRequest.listeSessionStatut.indexOf(Number(statut_session.id || 0)) === -1) {
      this.staticRequest.listeSessionStatut.push(Number(statut_session.id));
    } else {
      this.staticRequest.listeSessionStatut = this.staticRequest.listeSessionStatut.filter(elem => {
        return elem !== Number(statut_session.id);
      });
    }

    this.getAgenda();
  }

  getListStatut_session() {
    this.selectorService.getListStatutSession().subscribe(
      statut_session => {
        if (statut_session) {
          this.statut_session = statut_session;
          this.staticRequest.listeSessionStatut = [];
          for (const elem in statut_session) {
            if (statut_session[elem].code === 'ANNULE') continue;
            if (statut_session[elem].code === 'ARCHI') continue;
            this.staticRequest.listeSessionStatut.push(Number(statut_session[elem].id));
          }
          for (const el of this.bouttonsups) {
            this.staticRequest.listeSessionStatut.push(Number(el.id));
          }

          this.getAgenda();
        }
      },
      () => {
        this.staticRequest.listeSessionStatut = [];
        this.statut_session = [];
        this.getAgenda();
      }
    );
  }

  getFilterSelector(list: any[], selectorType: string) {
    switch (selectorType) {
      case 'site':
        (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite = [];
        (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite = Array.from(
          new Set(
            (this.staticRequest as MStaticClient.IStaticClientRequest).listeSite.concat(
              list.map(elm => elm.id.toString())
            )
          )
        );
        this.getAgenda();
        break;
      case 'produit':
        this.staticRequest.listeProduit = [];
        this.staticRequest.listeProduit = Array.from(
          new Set(this.staticRequest.listeProduit.concat(list.map(elm => elm.id.toString())))
        );
        this.getAgenda();
        break;
      case 'secteur':
        this.staticRequest.listeProduitSecteur = [];
        this.staticRequest.listeProduitSecteur = Array.from(
          new Set(this.staticRequest.listeProduitSecteur.concat(list.map(elm => elm.id.toString())))
        );
        this.getAgenda();
        break;
      case 'famille':
        this.staticRequest.listeProduitFamille = [];
        this.staticRequest.listeProduitFamille = Array.from(
          new Set(this.staticRequest.listeProduitFamille.concat(list.map(elm => elm.id.toString())))
        );
        this.getAgenda();
        break;
      case 'groupe':
        this.staticRequest.listeProduitGroupe = [];
        this.staticRequest.listeProduitGroupe = Array.from(
          new Set(this.staticRequest.listeProduitGroupe.concat(list.map(elm => elm.id.toString())))
        );
        this.getAgenda();
        break;
      case 'responsableadministratif':
        this.staticRequest.listResponsableAdministratif = [];
        this.staticRequest.listResponsableAdministratif = Array.from(
          new Set(this.staticRequest.listResponsableAdministratif.concat(list.map(elm => elm.id.toString())))
        );
        this.getAgenda();
        break;
    }
  }

  getAgenda() {
    this.filterClicked.emit(this.staticRequest);
  }
}
